import { useDoSpaceFileUploadMutation } from "store/services/doSpaceApi";
import { useAuth } from "./useAuth";

export const useDOUploadFile = () => {
  const [doFileUpload, { isLoading: uploadingFiles, error }] =
    useDoSpaceFileUploadMutation();
  const { viewEntity } = useAuth();

  async function handleUploadFiles(
    files,
    options = { folderName: "", entity: "", account: "" }
  ) {
    if (!options.folderName || !options.entity)
      throw new Error("Upload Options not satisfied!");

    if (!files?.length) return [];

    const uploadedFiles = [];

    for (const file of files) {
      if (file instanceof File)
        try {
          const upload = await doFileUpload({
            entityId: `${viewEntity.entity.account._id}`,
            filePath: `${viewEntity.entity._id}/${options.folderName}`,
            file: file,
          }).unwrap();

          const data = {
            name: upload.name,
            type: upload.type,
            size: upload.size,
            publicId: upload.publicId,
            url: upload.url,
          };
          uploadedFiles.push(data);
        } catch (err) {
          throw err;
        }
    }

    return {
      uploadedFiles,
    };
  }

  return {
    handleUploadFiles,
    uploadingFiles,
    error,
  };
};
